// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__container___cJ5tc {
    margin-left: 20px;
    margin-right: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.style__innerContainer___bO7qc {
    padding: 4px;
    border-radius: 12px;
    width: 110px;
    height: 110px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.style__highlight___dLhvV {
    background-color: var(--hover-color);
}

.style__image___O2JXq {
    width: 110px;
    height: 110px;
    /*object-fit: contain;*/
}

.style__imageFile___C0ooq {
    width: 80px;
    height: 80px;
    object-fit: contain;
}

.style__name___EUotE {
    text-align: center;
    margin-top: 10px;
    border-radius: 8px;
    padding: 4px;
    max-width: 110px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
}

.style__hoverColor___pVAho {
    background-color: #E6E6E6;
}

.style__placeholder___Q7FBb {
    color: lightgrey;
}

.style__cameraIcon___TV8CU {
    position: absolute;
    margin-top: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Folder/style.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":[".container {\n    margin-left: 20px;\n    margin-right: 20px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n}\n\n.innerContainer {\n    padding: 4px;\n    border-radius: 12px;\n    width: 110px;\n    height: 110px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.highlight {\n    background-color: var(--hover-color);\n}\n\n.image {\n    width: 110px;\n    height: 110px;\n    /*object-fit: contain;*/\n}\n\n.imageFile {\n    width: 80px;\n    height: 80px;\n    object-fit: contain;\n}\n\n.name {\n    text-align: center;\n    margin-top: 10px;\n    border-radius: 8px;\n    padding: 4px;\n    max-width: 110px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-size: 14px;\n}\n\n.hoverColor {\n    background-color: #E6E6E6;\n}\n\n.placeholder {\n    color: lightgrey;\n}\n\n.cameraIcon {\n    position: absolute;\n    margin-top: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style__container___cJ5tc`,
	"innerContainer": `style__innerContainer___bO7qc`,
	"highlight": `style__highlight___dLhvV`,
	"image": `style__image___O2JXq`,
	"imageFile": `style__imageFile___C0ooq`,
	"name": `style__name___EUotE`,
	"hoverColor": `style__hoverColor___pVAho`,
	"placeholder": `style__placeholder___Q7FBb`,
	"cameraIcon": `style__cameraIcon___TV8CU`
};
export default ___CSS_LOADER_EXPORT___;
